import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";

// Forward the parent's ref to AgGridReact so callers can access the grid API;
// refs are not passed through the normal props of a function component.
export const AgGridWithOverlay = React.forwardRef(function AgGridWithOverlay(
  {
    rowData,
    error,
    t,
    instructionKey = "common.clickGenerateReport",
    instructionDefault = "Click on Generate Report to see the data",
    onGridReady,
    ...props
  },
  ref,
) {
  const [gridApi, setGridApi] = useState(null);

  const hasSearched = Array.isArray(rowData);
  const hasError = !!error;
  const dataIsEmpty = !rowData?.length;

  useEffect(() => {
    if (gridApi) {
      if (dataIsEmpty) {
        gridApi.showNoRowsOverlay();
      } else {
        gridApi.hideOverlay();
      }
    }
  }, [hasSearched, hasError, dataIsEmpty, gridApi]);

  const getOverlayTemplate = () => {
    if (hasError) {
      return `<span class="ag-overlay-no-rows-center">${t(
        "common.errorOccurred",
        "An error occurred. Please try again later.",
      )}</span>`;
    }
    if (!hasSearched) {
      return `<span class="ag-overlay-no-rows-center">${t(
        instructionKey,
        instructionDefault,
      )}</span>`;
    }
    return `<span class="ag-overlay-no-rows-center">${t(
      "common.noRowsToShow",
      "No rows to show",
    )}</span>`;
  };

  const handleGridReady = (params) => {
    setGridApi(params.api);
    if (onGridReady) {
      onGridReady(params);
    }
  };

  return (
    <AgGridReact
      ref={ref}
      {...props}
      rowData={rowData}
      onGridReady={handleGridReady}
      overlayNoRowsTemplate={getOverlayTemplate()}
    />
  );
});
